import React from 'react';
import { Button } from '@trackman/web-shared-components';
import styled from 'styled-components';

export const StyledButton = styled((props) => <Button {...props} />)`
  width: 178px !important;
  -webkit-justify-content: flex-start !important;
  justify-content: flex-start !important;
`;
